export default "__VITE_ASSET__Bic2_9hn__"